export const campaignTypes = {
  DISCOVERY: 'DISCOVERY',
  SEARCH: 'SEARCH',
  BASIC: 'BASIC',
  D: 'DISCOVERY',
  S: 'SEARCH',
  B: 'BASIC',
};
